/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Proxy import completed successfully" |
*
* @param {Iconik_Proxy_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_success_toast = /** @type {((inputs?: Iconik_Proxy_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du proxy terminee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy-Import erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione proxy completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт через прокси успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La importación del proxy se completó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理导入已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシのインポートが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी आयात सफलतापूर्वक पूरा हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de proxy concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Proxy import completed successfully")
});